// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./_directives/appSelectRegion/appSelectRegion.less
 ** module id = 19
 ** module chunks = 0
 **/